import { apiFetch } from "../../Utils/apiFetch";
import { notifyError } from "../../Utils/CustomNotifcations";

export const getRoles = roles => ({
  type: 'GET_ROLES',
  roles
})
export const addRole = role => ({
  type: 'ADD_ROLE',
  role
})
export const updateRole = role => ({
  type: 'UPDATE_ROLE',
  role
})
export const removeRole = role => ({
  type: 'REMOVE_ROLE',
  role
})
export const sortRoles = roles => ({
  type: 'SORT_ROLES',
  roles
});


export const searchRole = role => ({
  type: 'SEARCH_ROLE',
  payload: role.role
});

export const fetchRolesApi = async (dispatch, logInUser) => {
  const url =
    logInUser.userType === -1
      ? `/api/roles?userId=${logInUser.id}&all=true`
      : `/api/roles?userId=${logInUser.id}`;

  try {
    const response = await apiFetch(url);
    if (!response.ok) throw new Error('Response not OK');
    const res = await response.json();
    console.error("data",res)
    
    if (res.status === 'success') {
      dispatch(getRoles(res.data));
    } else if (res?.statusCode === '440') {
      window.location.replace('/login');
    } else if (res.statusCode) {
      const err = res?.message.split(':');
      const msg = err[1]?.replace(')', '') || 'Unknown error';
      dispatch(notifyError(msg));
    }
  } catch (e) {
    dispatch(notifyError('somethingWentWrong'));
  }
};